// 체험 기간: 화면은 만료일 하나를 고르고(1달·100일 칩은 채우기 편의), 서버에는 기준일부터의 일수를 보낸다.
// 기준일은 신규·재개면 오늘, 연장이면 지금 만료일이다 (서버 trialSetup 과 같은 규칙).
// JSX 없이 순수 함수만 둔다 (테스트 대상).

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// yyyy-MM-dd ↔ 날짜 산술. UTC 로 계산해 실행 환경 시간대와 무관하게 같은 날짜가 나온다.
const toUtc = (date: string) => {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};
const fromUtc = (d: Date) => d.toISOString().slice(0, 10);

export const addDays = (date: string, days: number) => {
  const d = toUtc(date);
  d.setUTCDate(d.getUTCDate() + days);
  return fromUtc(d);
};

// 1달 뒤: 말일을 넘기지 않는다 (1/31 → 2/28)
export const addMonth = (date: string) => {
  const d = toUtc(date);
  const day = d.getUTCDate();
  d.setUTCDate(1);
  d.setUTCMonth(d.getUTCMonth() + 1);
  const lastDay = new Date(
    Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)
  ).getUTCDate();
  d.setUTCDate(Math.min(day, lastDay));
  return fromUtc(d);
};

export const daysBetween = (from: string, to: string) =>
  Math.round((toUtc(to).getTime() - toUtc(from).getTime()) / 86_400_000);

// 만료일 채우기 칩: 누르면 기준일에서 계산한 만료일이 들어간다
export const TRIAL_PERIOD_CHIPS: {
  label: string;
  expiration: (base: string) => string;
}[] = [
  { label: "1달", expiration: addMonth },
  { label: "100일", expiration: (base) => addDays(base, 100) },
];

// 기본 만료일: 기준일 + 1달
export const defaultTrialExpiration = (base: string) => addMonth(base);

// 서버에 보낼 일수. 만료일이 기준일보다 뒤가 아니면 null (설정할 수 없다)
export const trialDays = (base: string, expiration: string) => {
  if (!DATE_PATTERN.test(expiration)) return null;
  const days = daysBetween(base, expiration);
  return days > 0 ? days : null;
};
